import { Component } from '@angular/core';

@Component({
  selector: 'ngx-footer',
  styleUrls: ['./footer.component.scss'],
  template: `
    <span class="created-by">
      Desarrollado con ♥ por <b><a href="https://www.aidiapp.com" target="_blank">Aidiapp</a></b> 2025
    </span>
  `,
})
export class FooterComponent {
}
